import sentryIgnoreErrors from '@skillbox/sentry-ignore-errors'
import { init, captureException, browserTracingIntegration } from '@sentry/browser';

export const sentryInit = () => {
  /*eslint-disable */
  if (sentryDsn) {
    init({
      dsn: sentryDsn,
      environment: environment,
      ignoreErrors: sentryIgnoreErrors.errors,
      integrations: [
        browserTracingIntegration({
          tracePropagationTargets: [/^(https:\/\/)(.*)(skillbox.ru\/api\/|selcdn.ru).*/]
        })
      ],
      tracesSampleRate: 0.2
    });
  }

  window.Sentry = {
    captureException: (error, extra) => {
      captureException(error, extra);
    },
  };
  /*eslint-enable */
};
